import Color from 'color';
import {hexToRGB} from "./helpers/stylingHelpers";
import {translate, sprintf} from "./helpers/translate";

export const setupGlobals = () => {
    global.translate = translate;
    global.sprintf = sprintf;
    global.hexToRGB = hexToRGB;
    global.Color = Color;
};
